import { DefaultMessages, ProgramThemeMessages, SegmentSpecificMessages } from '@sheerid/jslib';
import { RecursivePartial } from '../types/types';


type LibraryMessages = DefaultMessages & SegmentSpecificMessages & ProgramThemeMessages;

type ThisProjectMessages = {
    optIn: string,
    step: {
        success: {
            redirect: string,
        }
    }
};

export const messagesKO: RecursivePartial<LibraryMessages & ThisProjectMessages> = {
    schoolName: '학교',
    infoShared1: ' ',
    informationTransferredToUS: ' ',
    infoShared2: '여기에 입력한 정보는 확인 목적으로 사용되며 {companyName} 회사와 공유됩니다.',
    optIn: `<a target="_blank" class="sid-link" href="https://www.sheerid.com/privacy-policy/">SheerID 개인 정보 보 호 정책</a>  및 <a target="_blank" class="sid-link" href="https://www.lenovo.com/privacy/">Lenovo 개인 정보 보호 정책에</a> 호 정책에 언급된 내 적격성을 확인하기 위한 정보 처리에 동의합니다. 내 정보는 Lenovo와 공유됩니다. 또한 미국으로 전송되어지고, SheerID의 개인 정보 보호 정책에 따라 처리됩니다.`,
    country:'국가/지역',
    countryPlaceholder:"국가/지역",
    countries: {
        HK: 'Hong Kong S.A.R. of China',
        TW: 'Taiwan Region',
    },
    step: {
        personalInfo: {
            title: '학생을 위한 간단 가입 페이지',
        },
        success: {
            subtitle: '쇼핑을 계속하려면 아래 버튼을 클릭하십시오. 할인은 장바구니에서 직접 적용됩니다.',
            redirectButtonText: 'Lenovo로 이동합니다.',
            redirect: 'Lenovo로 이동합니다.',
            emailNotification: '나중에도 쇼핑을 계속할 수 있도록 코드를 이메일로 보냈습니다. verify@sheerid.com 해당 이메일로 찾을 수 있습니다.'
        },
        emailLoop: {
            title:'이메일을 확인하세요',
            subtitleWithEmail:'인증 절차 완료를 위한 개인별 링크가 포함된 이메일이 {email}로 전송되었습니다.',
            subtitleWithoutEmail:'인증 절차 완료를 위한 개인별 링크가 포함된 이메일이 이메일 계정으로 전송되었습니다.',
            subtitle2:'자세한 내용은 당사(verify@sheerid.com)가 보낸 이메일을 확인하세요.',
            successResend:'이메일 전송 오류',
            resendButton:'재전송',
            errors:{
                resend:'이메일이 성공적으로 재전송되었습니다.',
            },
            skipEmail:'이 이메일을 복구할 수 없습니까? 계속하려면',
            skipEmailCTA:'여기',
            skipEmail2:'를 클릭하십시오.'
        }
    },
    requestSchool: '학교를 찾을 수 없나요? 리스트 등록을 요청하세요',
};
